export const getRaws = (cplData) =>
	cplData.map((item) => (
		<tr key={`${item.dateFrom}_${item.productName}`}>
			<td>{item.idx}</td>
			<td>{item.dateFrom}</td>
			<td>{item.dateTo}</td>
			<td>{item.productName}</td>
			<td>{item.leads}</td>
			<td>{item.cpl}</td>
			<td>{item.totalSpend}</td>
			<td>{parseFloat(item.wppkConfirmed)?.toFixed(2)}</td>
			<td>{parseFloat(item.wppkPayment)?.toFixed(2)}</td>
			<td>{parseFloat(item.wppkSum)?.toFixed(2)}</td>
			<td>{parseFloat(item.wppkDelivered)?.toFixed(2)}</td>
			<td>{parseFloat(item.wppkPaymentPaid)?.toFixed(2)}</td>
			<td>{parseFloat(item.wppkDeliveredSum)?.toFixed(2)}</td>
		</tr>
	));
